import axios from "axios";
import { ActionTypes } from "utils/constants";
import { getEnvVar } from "utils/get-env-var";

export const fetchResources = () => ({
    type: ActionTypes.FETCH_RESOURCES,
    payload: axios.get(`${getEnvVar('API_BASE')}/resources`)
});
